import {scrollIntakeToInvalid} from '@/intake/intakeUx'

/**
 * Mixin for intake / match form steps.
 * Call `this.noteInvalid()` after a failed validate (once, from submit).
 */
export default {
  methods: {
    clearInvalidCue() {
      const status = this.$el && this.$el.querySelector && this.$el.querySelector('.rb-ob-status')
      if (status) {
        status.classList.remove('is-error')
        status.setAttribute('aria-live', 'polite')
      }
    },
    isIntakeErrorStatus(val) {
      if (!val || typeof this.$t !== 'function') {
        return false
      }
      return (
        val === this.$t('intake.formIncomplete') ||
        val === this.$t('intake.fieldRequired') ||
        val === this.$t('intake.checkoutHoldExpired')
      )
    },
    /** Highlight status only (no scroll) — e.g. hold expired. */
    noteStatusError() {
      this.$nextTick(() => {
        const status = this.$el && this.$el.querySelector && this.$el.querySelector('.rb-ob-status')
        if (status) {
          status.setAttribute('aria-live', 'assertive')
          status.classList.add('is-error')
        }
      })
    },
    noteInvalid() {
      this.$nextTick(() => {
        scrollIntakeToInvalid(this.$el)
        const status = this.$el && this.$el.querySelector && this.$el.querySelector('.rb-ob-status')
        if (status) {
          status.setAttribute('aria-live', 'assertive')
          status.classList.add('is-error')
        }
      })
    },
  },
  watch: {
    formStatus(val) {
      this.$nextTick(() => {
        if (this.isIntakeErrorStatus(val)) {
          const status = this.$el && this.$el.querySelector && this.$el.querySelector('.rb-ob-status')
          if (status) {
            status.setAttribute('aria-live', 'assertive')
            status.classList.add('is-error')
          }
          return
        }
        this.clearInvalidCue()
      })
    },
  },
}
